import { cn } from '@repo/ui/lib/utils'
import { cva, VariantProps } from 'class-variance-authority'
import { useTranslation } from 'react-i18next'

export type SpinnerProps = React.ComponentPropsWithoutRef<'div'> &
  VariantProps<typeof spinnerVariants>

const spinnerVariants = cva('inline-block rounded-full box-border animate-spin', {
  variants: {
    size: {
      xs: 'size-4 border-[3px]',
      sm: 'size-5 border-[3px]',
      md: 'size-6 border-[4px]',
      lg: 'size-8 border-[4px]',
      xl: 'size-10 border-[5px]',
    },
    color: {
      default: 'border-alpha-300 border-b-foreground',
      inverted: 'border-white/30 border-b-white',
      blue: 'border-alpha-300 border-b-info',
    },
    speed: {
      slow: 'duration-1000',
      medium: 'duration-700',
      fast: 'duration-500',
    },
  },
  defaultVariants: {
    size: 'md',
    color: 'default',
    speed: 'slow',
  },
})

export function Spinner(props: SpinnerProps) {
  const { t } = useTranslation('common')
  const { size, color, speed, className, ...rest } = props

  return (
    <div role="status" className={cn(spinnerVariants({ size, color, speed }), className)} {...rest}>
      <span className="sr-only">{t('loading')}</span>
    </div>
  )
}
